export default __webpack_public_path__ + "static/media/pathBackground.4bf3d007.svg";